import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { SharedModule } from '../shared.module';
import { PriceInformationComponent } from './price-information.component';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { TreoAutofocusModule } from '@treo/directives/autofocus';
import { NgxMaskDirective } from 'ngx-mask';

@NgModule({
  declarations: [PriceInformationComponent],
  imports: [
    SharedModule,
    MatProgressBarModule,
    TreoAutofocusModule,
    FormsModule,
    NgxMaskDirective,
  ],
  exports: [PriceInformationComponent],
})
export class PriceInformationModule {}
